<template>
    <div id="app" :class="appClass">
        <navigation/>
        <router-view/>
        <Footer/>
    </div>
</template>
<script>
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import {EventBus, events} from '@/utils/event-bus';
import {mapGetters} from "vuex";
import api from "@/utils/api";
import ClearStoreMixin from "@/mixins/ClearStoreMixin";

import "cookieconsent/build/cookieconsent.min.css"

const snakeCase = require('lodash.snakecase');
if(document.cookie.indexOf('cookieconsent_status') < 0) {
    require("cookieconsent/src/cookieconsent");
}
export default {
    mixins: [ClearStoreMixin],
    computed: {
        appClass: function () {
            return snakeCase("route_" + this.$route.name);
        },
        ...mapGetters('auth', [
            'isGuest'
        ]),
    },
    components: {
        Navigation, Footer
    },
    mounted() {
        let that = this;
        EventBus.$on(events.auth.signout, function () {
            api.token = null
            that.$store.commit('auth/clear');
            that.clearStore()
            that.$router.push({name: 'Home'});
        });
        EventBus.$on(events.auth.notVerified, function (){
            that.$store.commit('auth/setNotVerified')
            that.$router.push({name: 'RegisterDone'});
        })
        EventBus.$on(events.auth.missingDirectDebit, function (){
            if(!that.$store.getters['auth/isFresh']) {
                that.$store.commit('auth/setDirectDebit', false)
                that.$router.push({name: 'SetupDebit'});
            }
        })
    
        
        if(window.cookieconsent){
            
            let policy_url = '/cookie-policy';
            window.cookieconsent.initialise({
                palette: {
                    popup: {
                        background: "#ecf0f5",
                        text: "#252528"
                    },
                    button: {
                        background: "#009846",
                        text: "#ffffff"
                    }
                },
                theme: "classic",
                content: {
                    link: 'Cookies Policy',
                    href: policy_url,
                    message: 'This website uses cookies to provide a better and safer experience. By clicking on or navigating the site, you agree to this use. Learn more: ',
                }
            });
        }
    },
    destroyed() {
        EventBus.$off(events.auth.signout);
        EventBus.$off(events.auth.notVerified);
        EventBus.$off(events.auth.missingDirectDebit);
    }
}
</script>
